import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { RefreshCw, Sparkles } from 'lucide-react';

const UpdateToast = ({ isVisible, onDismiss, onRefresh }) => {
  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ type: 'spring', damping: 25 }}
          className="fixed bottom-6 right-6 z-50"
        >
          <div className="bg-gradient-to-br from-blue-600 to-indigo-700 text-white rounded-xl shadow-xl overflow-hidden w-80">
            <div className="p-5">
              <div className="flex items-start gap-3">
                <div className="p-2 bg-white/20 rounded-full">
                  <Sparkles size={20} className="text-yellow-300" />
                </div>
                <div className="flex-1">
                  <h3 className="font-bold text-lg mb-1">Exciting Update Available!</h3>
                  <p className="text-sm opacity-90">
                    We've rolled out new features and improvements. Refresh to enjoy the enhanced experience!
                  </p>
                </div>
              </div>
              
              <div className="mt-4 flex justify-between items-center">
                <button 
                  onClick={onDismiss}
                  className="text-xs font-medium opacity-80 hover:opacity-100 transition"
                >
                  Maybe later
                </button>
                <button
                  onClick={onRefresh}
                  className="flex items-center gap-2 bg-white/20 hover:bg-white/30 px-4 py-2 rounded-lg text-sm font-medium transition-all"
                >
                  <RefreshCw size={16} />
                  Hard Refresh Now
                </button>
              </div>
            </div>
            
            <div className="h-1 bg-gradient-to-r from-yellow-400 to-pink-500 w-full"></div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default UpdateToast;